import { useIsFeatureOn } from 'hooks/useFeatureSwitch/useIsFeatureOn';

// Guards REST queries against the initial frame where features are still
// loading — prevents spurious API calls before the project is fully hydrated.
// useStreamEnabled / useStreamSwitch have been removed; stream is always on.
export function useRestApiEnabled(): boolean {
  const { isLoadingFeatures } = useIsFeatureOn();
  return !isLoadingFeatures;
}
